import { FeatureState } from "../../__personal/components/global/FeatureState";
import { env } from "../Env";
import { rqx } from "./API";

export const createPersonalization = async(_req) =>{
    let _res = await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env() }/personalization/create`, _req)
    return _res;
}

export const getAllPersonalization = async(_req) =>{
    let _res = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env() }/personalization/read`, _req)
    return _res;
}

export const createPrimaryInfo = async(_req) => {
    let _res = await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env() }/primeinfo/create`, _req);
    return _res;
}

export const updatePrimaryInfo = async(_req) => {
    let _res = await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env() }/primeinfo/update`, _req);
    return _res;
}
export const getPrimaryInfo = async(_req) => {
    let _res = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env() }/primeinfo/read`, _req);
    return _res;
}

export const getGlobalProfession = async(_req) => {
    let _res = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env() }/profession/userProfession`, _req);
    return _res;
}

// Multiple profession
export const createGlobalProfession = async(_req) => {
    let _res = await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env() }/profession/createUserProfession`, _req);
    return _res;
}
//Single Profession
export const createAcadUserProfession = async(_req) => {
    let _res = await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env() }/profession/createAcadUserProfession`, _req);
    return _res;
}

// GLOBAL DAU GET DAILY
export const getDAU = async(_req) => {
    let _res = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env() }/trail/activeuser`, _req);
    return _res;
}

export const createActiveUser = async(_req) => {
    let _res = await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env() }/trail/create`, _req);
    return _res;
}

// ------PSL ACAD------
export const getProfession = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env() === 'local' ? 'dev' : env() }/certificate/professionRead`, _req);
    return _res;
}

// ------BIZ ACAD------
// TRAININGS - TOPIC READ VIEW CREATE UPDATE
export const getTopic = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env() === 'local' ? 'dev' : env() }/biz_trainings/topic_read`, _req);
    return _res;
}
export const postedTopic = async(_req) => {
    let _res = await rqx.post(`<<tool>>/${env() === 'local' ? 'dev' : env() }/biz_trainings/topic_post`, _req);
    return _res;
}

export const cu = async(_req, type) => {
    let _res = await rqx.post(`<<tool>>/${env() === 'local' ? 'dev' : env() }/biz_provider/${type}`, _req);
    return _res;
}

export const topic_view = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_trainings/topic_view`, _req);
    return _res;
}
export const topic_create = async(_req) => {
    let _res = await rqx.post(`<<tool>>/${env()}/biz_trainings/topic_create`, _req);
    return _res;
}
export const topic_update = async(_req) => {
    let _res = await rqx.post(`<<tool>>/${env()}/biz_trainings/topic_update`, _req);
    return _res;
}

// VIDEO SET UP
export const video_setup_getTopic = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_trainings/video_setup_getTopic`, _req);
    return _res;
}

export const video_setup_cu = async(_req) => {
    let _res = await rqx.post(`<<tool>>/${env()}/biz_trainings/video_setup_cu`, _req)
    return _res;
}

export const video_setup_List = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_trainings/video_setup_List`, _req)
    return _res;
}

export const video_setup_getRead = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_trainings/video_setup_getRead`, _req)
    return _res;
}

// EXAM SETUP
export const exam_getTopic = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_exam/getTopic`, _req)
    return _res;
}

export const exam_getTrainingExam = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_exam/getTrainingExam`, _req)
    return _res;
}

//  DASHBOARD
export const admin_topic_graph = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_dashboard/admin_topic_graph`, _req)
    return _res;
}

export const admin_exam_graph = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_dashboard/admin_exam_graph`, _req)
    return _res;
}

export const admin_topic_list = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_dashboard/admin_topic_list`, _req)
    return _res;
}

export const admin_exam_list_quiz = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_dashboard/admin_exam_list_quiz`, _req)
    return _res;
}

// REPORTS
export const report_training_read = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_report/report_training_read`, _req)
    return _res;
}

export const report_user_training_list = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_report/report_user_training_list`, _req)
    return _res;
}

export const report_pqpe = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_report/report_pqpe`, _req)
    return _res;
}

export const report_pretest_users = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_report/report_pretest_users`, _req)
    return _res;
}

export const report_quiz_users = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_report/report_quiz_users`, _req)
    return _res;
}

export const report_post_evaluation_users = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_report/report_post_evaluation_users`, _req)
    return _res;
}

export const report_post_evaluation_export = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_report/report_post_evaluation_export`, _req)
    return _res;
}

export const training_title = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_trainings/training_title`, _req)
    return _res;
}

// PROVIDER
export const provider_read = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/biz_provider/read`, _req)
    return _res;
}


// FEATURE STATE LOGS
export const feature_logs_create = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/trail/featurelogs`, _req)
    return _res;
}

export const feature_logs_read = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/trail/featurelogs`, _req)
    return _res;
}

export const feature_logs_update = async(_req) => {
    let _res = await rqx.get(`<<tool>>/${env()}/trail/featurelogs`, _req)
    return _res;
}

// PERSONALIZATION PSL AND BIZ
// export const StartHereRead = async(_req) => {
//     try {
//         let _res = await rqx.get(`<<tool>>/${env()}/biz/start/read`, _req)
//         return _res;
//     } catch (error) {
//         return "error"
//     }
// }


// TOOL USAGE

export const GetToolUsage = async(qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/readToolUsage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/readToolUsage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const GetToolActivePercentage = async(qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/usagePercentage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/activePercentage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const GetToolAwarePercentage = async(qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/usagePercentage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/awarePercentage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const GetToolUsagePercentage = async(qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/usagePercentage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/usagePercentage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const GetToolMostUsedPage = async(qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/mostUsedPage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/mostUsedPage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const GetToolUsageDetails = async(qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/mostUsedPage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/usageDetails`, qsp)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const CreateFeatureLogs = async(body) => {
    try {
        let result = await rqx.post(`<<global>>/${env()}/trail/featurelogs`, body)
        return result
    } catch (error) {
        return 'error'
    }   
}

export const FeatureLogs = async(name, action, aid) => { 
    console.log(name)
    let ftrdata = await FeatureState(name) || console.log('Feature Name is Not Found!')
    if (ftrdata) { 
        let body = { 
            aid: aid, 
            tid:process.env.REACT_APP_TID_BIZ, 
            company_id:0, 
            feature_id:ftrdata?.id, 
            feature_name:ftrdata?.feature_name, 
            path:ftrdata?.path, 
            action: action, // 1 = Create, 2 = Read, 3 = Update  
        }
        console.log(body)
    //     await feature_logs_create(body)
    } 
} 

